export default __webpack_public_path__ + "static/media/UnderactiveIcon.e87b5d6b.svg";